import React, { FC, useEffect, useRef } from 'react';
import { path, pathOr } from 'ramda';
import { Description, MoreDetailsButton, Name, Price } from '../shared';
import Wrapper from '../Wrapper';
import Image from '../Image';

import { LayoutProps } from '../layoutProps';
import {
  DetailWrapper,
  NamePrice,
  DescriptionWrapper,
  DescriptionRow,
  MoreDetailsGuestSelect,
} from './WideLayout.styles';

const WideLayout: FC<LayoutProps> = ({
  description,
  featured,
  hideDetails,
  imageUrl,
  isSelected,
  isShowingDetails,
  name,
  price,
  pricePerNight,
  showDetails,
  showPrice,
  controls,
  pricingType,
  quantityLabel,
}) => {
  const descriptionRef = useRef(null);
  const moreDetailsRef = useRef(null);

  useEffect(() => {
    if (featured) {
      return;
    }
    // trigger transitions
    const descriptionElement = path(['current'], descriptionRef);
    const moreDetailsElement = path(['current'], moreDetailsRef);
    const moreDetailsStyle = path(['children', '0', 'style'], moreDetailsElement);

    if (!isShowingDetails) {
      descriptionElement.style.maxHeight = '0';
      moreDetailsStyle.marginBottom = '0';
      return;
    }

    const descriptionHeight = pathOr(0, ['children', '0', 'clientHeight'], descriptionElement);
    const contentHeight = pathOr(
      0,
      ['children', '0', 'children', '0', 'scrollHeight'],
      descriptionElement
    );
    descriptionElement.style.maxHeight = `${descriptionHeight + contentHeight}px`;

    const { clientHeight: moreDetailsHeight } = moreDetailsElement;
    moreDetailsStyle.marginBottom = `${moreDetailsHeight - 24}px`;
  }, [descriptionRef, moreDetailsRef, isShowingDetails, featured]);

  return (
    <Wrapper featured={featured} isSelected={isSelected}>
      <Image
        alt={name}
        className={isShowingDetails ? 'open' : ''}
        featured={featured}
        imageUrl={imageUrl}
        isWiderViewport
      />
      <DetailWrapper>
        <NamePrice isShowingDetails={isShowingDetails}>
          <Name name={name} />
          <Price
            price={price}
            pricePerNight={pricePerNight}
            showPrice={showPrice}
            pricingType={pricingType}
            quantityLabel={quantityLabel}
          />
        </NamePrice>
        <DescriptionRow ref={descriptionRef}>
          <DescriptionWrapper>
            <Description description={description} />
            <div />
          </DescriptionWrapper>
        </DescriptionRow>
        <MoreDetailsGuestSelect ref={moreDetailsRef}>
          {featured && <div />}
          <MoreDetailsButton
            details={description}
            featured={featured}
            isShowingDetails={isShowingDetails}
            showDetails={showDetails}
            hideDetails={hideDetails}
            isWiderViewport
          />
          {controls}
        </MoreDetailsGuestSelect>
      </DetailWrapper>
    </Wrapper>
  );
};

export default WideLayout;
